document.addEventListener('change', (event) => {
    let element = event.target;
    if (element && element.matches('.form-element-field')) {
        element.classList[element.value ? 'add' : 'remove']('-hasvalue');
    }
});
